export const wavesurferjs = '../static/WaveSurfer/wavesurfer.js'

export const utiljs = '../static/WaveSurfer/util.js'

export const webaudiojs = '../static/WaveSurfer/webaudio.js'

export const mediaelementjs = '../static/WaveSurfer/mediaelement.js'

export const drawerjs = '../static/WaveSurfer/drawer.js'

export const drawerCanvasjs = '../static/WaveSurfer/drawer.canvas.js'

export const audiosequencejs = '../static/WaveSurfer/audiosequence.js'

export const wavesurferEditorjs = '../static/WaveSurfer/wavesurfer.editor.js'

export const wavesurferRegionsjs = '../static/WaveSurfer/wavesurfer.regions.js'

export const wavesurferTimelinejs = '../static/WaveSurfer/wavesurfer.timeline.js'

export const wavesurferMinimapjs = '../static/WaveSurfer/wavesurfer.minimap.js'
